let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5E9T2")).then(() => parcelRequire('fWDoI'));